module.exports = __webpack_public_path__ + "static/media/6mentors.1012b386.png";